import React, { useState, useEffect } from "react";
import { Breadcrumb } from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";

import queryString from "app/services/queryStringService";
import _, { isRegExp } from "lodash";
import { MdEdit, MdVpnKey, MdSearch, MdRefresh } from "react-icons/md";
import { apiUrl } from "../../../../config.json";
import Swal from "sweetalert2";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import {
  Accordion,
  Button,
  DropdownButton,
  Dropdown,
  Form,
  Row,
} from "react-bootstrap";
import Tooltip from "rc-tooltip";
import MarkupModal from "./MarkupModal";

import { getMarkUp, addMarkUp } from "app/services/markUpService";
import { NotificationManager } from "react-notifications";
import usePagePermission from "app/hooks/usePagePermission";
import HandyScroll from "app/common/Scroll";

const Markup = () => {
  const { canAdd, canView, canEdit, canDelete } = usePagePermission();
  // console.log({ canAdd, canView, canEdit, canDelete });

  const [page, setPage] = useState(1);
  const [data, setData] = useState([]);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [dataCount, setDataCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const [show, setShow] = useState(false);
  const [editId, setEditId] = useState(0);
  const [editRow, setEditRow] = useState(null);
  const [id, setId] = useState(0);
  const [markupName, setMarkupName] = useState("");
  const [markupDescription, setMarkupDescription] = useState("");
  const [domesticMarkup, setDomesticMarkup] = useState("");
  const [internationalMarkup, setInternationalMarkup] = useState("");
  const [isDefault, setIsDefault] = useState(true);
  const [isActive, setIsActive] = useState("");
  const [isRefreshed, setIsRefreshed] = useState(false);
  const [isShowFilter, setIsShowFilter] = useState(false);

  const handleSearchChanges = (e) => {
    const { name, value } = e.target;
    switch (name) {
      case "markupName":
        setMarkupName(value);
        break;
      case "markupDescription":
        setMarkupDescription(value);
        break;
      case "domesticMarkup":
        setDomesticMarkup(value);
        break;
      case "internationalMarkup":
        setInternationalMarkup(value);
        break;
      case "isActive":
        setIsActive(value);
        break;
      default:
        break;
    }
  };

  const refreshFilter = (e) => {
    setMarkupName("");
    setMarkupDescription("");
    setDomesticMarkup("");
    setInternationalMarkup("");
    setIsDefault(true);
    setIsActive("");
    setIsRefreshed(true);
  };
  // useEffect(() => {
  //   if (isRefreshed) {
  //     loadMarkup();
  //   }
  // }, [isRefreshed]);

  const statusFormatter = (cell, row) => {
    if (row.isActive === true) {
      return <span className="text-success"> Active </span>;
    } else {
      return <span className="text-danger"> Inactive</span>;
    }
  };

  const editHandler = (row) => {
    setEditId(row.id);
    setEditRow(row);
    handleShow();
  };

  const actionFormatter = (cell, row) => {
    return (
      <>
        {/* <DropdownButton variant="outline-primary" title="Action" size="sm">
          <Dropdown.Item onClick={() => editHandler(row)}> */}
        <MdEdit
          cursor={"pointer"}
          className="text-black mr-4"
          size={15}
          onClick={() => editHandler(row)}
        ></MdEdit>
        {/* Edit
          </Dropdown.Item>
        </DropdownButton> */}
      </>
    );
  };

  const updateDefaultMarkUp = async (row) => {
    Swal.fire({
      title: `Are you sure you want to ${
        row.isDefault === true ? "inactive" : "Set Default"
      } the MarkUp?`,
      icon: "warning",
      type: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      showLoaderOnConfirm: true,
    }).then(async (result) => {
      if (result.value) {
        let data = {
          id: row.id,
          markupName: row.markupName,
          markupDescription: row.markupDescription,
          domesticMarkup: row.domesticMarkup,
          internationalMarkup: row.internationalMarkup,
          isDefault: !row.isDefault,
          isActive: row.isActive,
        };
        console.log(data.id);
        console.log(data.isDefault);
        // debugger;
        const result = await addMarkUp(data);

        try {
          if (!row.isDefault === true) {
            NotificationManager.success(" MarkUp Set Default successfully");
          } else {
            NotificationManager.error("Inactive successfully");
          }
        } catch (error) {
          NotificationManager.error("something went to be wrong");
          console.log(error);
        }

        loadMarkup();
      } else {
        Swal.fire({
          title: "Cancelled!",
          text: "Permission denied.",
          type: "error",
          icon: "error",
          timer: 1500,
        });
      }
    });
  };

  const setDefaultFormatter = (cell, row) => {
    return (
      <span>
        <div className="row ">
          <div className="col-md">
            <div
              className=" d-flex justify-content-center"
              style={{ cursor: "pointer" }}
            >
              <Tooltip
                style={{ marginLeft: "-1pc" }}
                placement="left"
                overlay={
                  row.isActive === false
                    ? "Status Inactive"
                    : row.isDefault === true
                    ? "Click to  Inactive"
                    : "Click to  Set Default"
                }
              >
                <span>
                  <Form.Check
                    disabled={row.isActive === false}
                    type="switch"
                    id={`custom-switch${row.id}`}
                    checked={row.isDefault}
                    onChange={() => updateDefaultMarkUp(row)}
                  />
                </span>
              </Tooltip>
            </div>
          </div>
        </div>
      </span>
    );
  };

  const columns = [
    {
      dataField: "markupName",
      text: "Markup Name",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "markupDescription",
      text: "Markup Description",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "domesticMarkup",
      text: "Domestic Markup",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "internationalMarkup",
      text: "International Markup",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
    },
    {
      dataField: "isActive",
      text: "Status",
      headerStyle: (colum, colIndex) => {
        return { textAlign: "center", width: "150px" };
      },
      formatter: statusFormatter,
    },
    {
      dataField: "isDefault",
      text: "Set Default",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: setDefaultFormatter,
    },
    {
      dataField: "id",
      text: "Action",
      headerStyle: (colum, colIndex) => {
        return { width: "100px", textAlign: "center" };
      },
      formatter: actionFormatter,
    },
  ];

  const rowStyle = (row, rowIndex) => {
    const style = {};
    style.textAlign = "center";
    style.fontWeight = "600";
    style.verticalAlign = "center";
    return style;
  };

  const NoDataIndication = () => {
    if (loading) {
      return (
        <div className="jumbotron jumbotron-fluid min-vh-80 m-0 bg-white"></div>
      );
    } else {
      return (
        <div className="jumbotron min-vh-80 text-middle m-0 text-center d-flex flex-column justify-content-center">
          <span className="align-middle"></span>
          <p> No Data Found</p>
        </div>
      );
    }
  };
  const sizePerPageRenderer = ({
    options,
    currSizePerPage,
    onSizePerPageChange,
  }) => (
    <>
      <label className="mr-2">Page Size</label>
      <div className="btn-group mr-4" role="group">
        {options.map((option, i) => {
          const isSelect = currSizePerPage === `${option.page}`;
          return (
            <button
              key={option.text}
              type="button"
              onClick={() => onSizePerPageChange(option.page)}
              className={`btn btn-sm ${
                isSelect ? "btn-primary" : "btn-secondary"
              }`}
            >
              {option.text}
            </button>
          );
        })}
      </div>
    </>
  );

  const paginationOptions = {
    paginationSize: 5,
    pageStartIndex: 1,
    firstPageText: "First",
    prePageText: "Back",
    nextPageText: "Next",
    lastPageText: "Last",
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    totalSize: dataCount,
    sizePerPageList: [
      {
        text: "10",
        value: 10,
      },
      {
        text: "15",
        value: 15,
      },
      {
        text: "20",
        value: 20,
      },
      {
        text: "50",
        value: 50,
      },
    ],
    sizePerPageRenderer,
  };
  const loadMarkup = async () => {
    const query = queryString.getQueryStringFromObj({
      pageNumber: page,
      pageSize: sizePerPage,
      markupName,
      markupDescription,
      domesticMarkup,
      internationalMarkup,
      isActive,
      isDefault,
    });
    if (dataCount !== 0) {
      setLoading(true);
    }
    const response = await getMarkUp(query);

    const data = response.data.data;
    const paggingData = JSON.parse(response.headers["x-pagination"]);
    setData(data);
    setDataCount(paggingData.TotalCount);
    setPage(paggingData.CurrentPage);
    setSizePerPage(paggingData.PageSize);
    setLoading(false);
  };

  useEffect(() => {
    loadMarkup();
  }, [
    page,
    sizePerPage,
    markupName,
    markupDescription,
    domesticMarkup,
    internationalMarkup,
    isActive,
    isDefault,
  ]);

  const handleTableChange = async (type, { page, sizePerPage }) => {
    setPage(page);
    setSizePerPage(sizePerPage);
    setTimeout(async () => {
      await loadMarkup();
    }, 10);
  };

  const handleSearch = async () => {
    setPage(1);
    setSizePerPage(10);
    setIsRefreshed(false);
    setTimeout(async () => {
      await loadMarkup();
    }, 10);
  };

  const handleClose = () => {
    setShow(false);
    setTimeout(async () => {
      await loadMarkup();
    }, 10);
  };

  const handleShow = () => {
    setShow(true);
  };

  return (
    <div>
      {canAdd && (
        <Link
          className="btn btn-primary btn-md float-end"
          to="#"
          variant="primary"
          onClick={() => {
            setEditRow(null);
            handleShow();
          }}
        >
          <i className="i-Add-User text-white mr-2"></i> Add Mark up
        </Link>
      )}
      <MarkupModal
        show={show}
        handleClose={handleClose}
        handleShow={handleShow}
        editRow={editRow}
      />
      <Helmet>
        <title>Flight MarkUp</title>
      </Helmet>
      <Breadcrumb routeSegments={[{ name: "Flight MarkUp" }]}></Breadcrumb>

      {/* // filter */}

      <div className=" col-12 d-flex flex-row-reverse mb-2">
        <Button
          variant="primary"
          onClick={() => setIsShowFilter(!isShowFilter)}
        >
          Filter
          <i className="i-Filter-2 ml-2 mt-1"></i>
        </Button>
      </div>

      {isShowFilter ? (
        <div className="card card-body rounded border my-1">
          <div className="row">
            <div className="col-md-2 col-12 mb-1">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <MdVpnKey />
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="markupName"
                  placeholder="MarkUp Name"
                  value={markupName}
                  name="markupName"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Conference"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="markupDescription"
                  placeholder="MarkUp Description"
                  value={markupDescription}
                  name="markupDescription"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Checked-User"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="domesticMarkup"
                  placeholder="Domestic MarkUp"
                  value={domesticMarkup}
                  name="domesticMarkup"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>
            <div className="col-12 col-md-2">
              <div className="input-group mb-3">
                <span
                  className="input-group-text"
                  id="inputGroup-sizing-default"
                >
                  <i className="i-Checked-User"></i>
                </span>

                <input
                  type="text"
                  className="form-control"
                  id="internationalMarkup"
                  placeholder="International MarkUp"
                  value={internationalMarkup}
                  name="internationalMarkup"
                  onChange={handleSearchChanges}
                />
              </div>
            </div>

            <div className="col-12 col-md-2 ">
              <select
                className="form-control mb-3"
                value={isActive}
                name="isActive"
                onChange={handleSearchChanges}
              >
                <option value=""> Select Status</option>

                <option value="true"> Active</option>
                <option value="false"> InActive</option>
              </select>
            </div>

            <div className="col-12  col-md-2  d-flex justify-content-around mb-3">
              <button
                className="btn btn-outline-primary mr-3"
                onClick={handleSearch}
              >
                <MdSearch className="mx-2" size={18} />
              </button>
              <button
                className="btn btn-outline-primary"
                onClick={() => refreshFilter()}
              >
                <MdRefresh className="mx-2" size={18} />
              </button>
            </div>
          </div>
        </div>
      ) : (
        <></>
      )}
      <HandyScroll>
        <div
          class="spacious-container"
          data-handy-scroll
          style={{ overflow: "auto" }}
        >
          <BootstrapTable
            hover
            remote
            keyField="id"
            data={data}
            columns={
              canEdit ? columns : columns.filter((x) => x.text !== "Action")
            }
            pagination={paginationFactory(paginationOptions)}
            onTableChange={handleTableChange}
            noDataIndication={() => <NoDataIndication />}
            headerClasses="bg-primary text-white"
            bodyClasses="react-bootstrap-table-next-min-height"
            rowStyle={rowStyle}
          />
        </div>
      </HandyScroll>
    </div>
  );
};

export default Markup;
